'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgCheckboxSelectedFilled16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 16, fill: "none" }, props),
    React__namespace.createElement("path", { fill: props.fillColor, fillRule: "evenodd", clipRule: "evenodd", d: "M1.172 1.172C0 2.343 0 4.229 0 8c0 3.771 0 5.657 1.172 6.828C2.343 16 4.229 16 8 16c3.771 0 5.657 0 6.828-1.172C16 13.657 16 11.771 16 8c0-3.771 0-5.657-1.172-6.828C13.657 0 11.771 0 8 0 4.229 0 2.343 0 1.172 1.172zm11.622 4.22a.843.843 0 0 0-.079-1.184.83.83 0 0 0-1.175.078l-5.247 6.036-1.87-1.882a.83.83 0 0 0-1.179 0 .843.843 0 0 0 0 1.186l1.87 1.883a1.66 1.66 0 0 0 2.433-.082l5.247-6.036z" })));

exports.default = SvgCheckboxSelectedFilled16;
//# sourceMappingURL=CheckboxSelectedFilled16.js.map
